import { processSplash } from '../processSplash';

import css from './assets/logoSpinner.css';
import html from './assets/logoSpinner.html';

export const logoSpinner = processSplash(html, css);
